// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g7e8J","colBig":"styles_colBig__3qMVh","colSmall":"styles_colSmall__3IdTo"};